import { USER_DASHBOARD_PAGE_KEY } from '../constants';
import { routesLocalesPt } from '../routes/i18n';
import { savedCoursesPt } from '../routes/SavedCourses/i18n';
import { EXTERNAL_LOCALES_PT } from './externals';

const pt = {
  [USER_DASHBOARD_PAGE_KEY]: {
    ...routesLocalesPt,
    ...savedCoursesPt,
    // Titles
    UD_ENROLLMENTS_TITLE: 'Meus cursos',
    UD_ENROLLMENTS_COURSES: 'Todos os meus cursos',
    UD_ENROLLMENTS_TRACKS: 'Minhas especializações',
    UD_ENROLLMENTS_CAREERS: 'Minhas carreiras',
    UD_ENROLLMENTS_BUNDLES: 'Meus certificados',
    UD_ENROLLMENTS_DEGREES: 'MicroDegree',
    UD_ENROLLMENTS_ACADEMIES: 'Academias',
    UD_ENROLLMENTS_NEW_TAG: 'Novo',
    UD_ENROLLMENTS_BOOTCAMPS: 'Bootcamp',
    UD_CLASSNOTES_TITLE: 'Minhas anotações',
    UD_PROJECTS_TITLE: 'Meus projetos',
    UD_DIPLOMAS_TITLE: 'Meus diplomas',
    UD_STUDY_PLAN_TITLE: 'Meu plano de estudos',
    // Onboarding
    UD_ONBOARDING_WELCOME_TITLE: 'Seja bem-vindo ao seu novo painel de alunos!',
    UD_ONBOARDING_WELCOME_DESC:
      'Falamos sobre as novas melhorias que temos para você.',
    UD_ONBOARDING_MOBILE_MENU_TITLE: 'Nova barra de menus',
    UD_ONBOARDING_MOBILE_MENU_DESC:
      'Implementamos uma nova barra de menus para que você tenha uma melhor navegação entre as seções de Meus cursos, Minhas anotações, Meus projetos, Meus diplomas e Meu plano de estudos.',
    UD_ONBOARDING_ENROLLMENTS_TITLE: 'Meus cursos',
    UD_ONBOARDING_ENROLLMENTS_DESC:
      'Aqui você encontrará não só todos seus cursos registrados, mas também o andamento de suas especializações.',
    UD_ONBOARDING_CLASSNOTES_TITLE: 'Minhas anotações',
    UD_ONBOARDING_CLASSNOTES_DESC:
      'Todas as anotações feitas em todos os seus cursos podem ser revisadas aqui.',
    UD_ONBOARDING_PROJECTS_TITLE: 'Meus projetos',
    UD_ONBOARDING_PROJECTS_DESC:
      'Encontre nesta seção todos os projetos em que você está trabalhando. Você também pode visualizar o status da revisão de cada um, mesmo aqueles que já estão certificados.',
    UD_ONBOARDING_DIPLOMAS_TITLE: 'Meus diplomas',
    UD_ONBOARDING_DIPLOMAS_DESC:
      'Encontre seus diplomas da Crehana aqui, depois que seu projeto final for aprovado.',
    UD_ONBOARDING_STUDY_PLAN_TITLE: 'Meu plano de estudos',
    UD_ONBOARDING_STUDY_PLAN_DESC:
      'Você sabia que as pessoas mais bem-sucedidas geram hábitos? Nesta seção, ajudamos você a atingir seus objetivos.',
    UD_ONBOARDING_NIGHT_SWITCH_TITLE: 'Juntar-se ao lado escuro',
    UD_ONBOARDING_NIGHT_SWITCH_DESC:
      'Personalize o seu painel para o modo noturno ativando esta opção.',
    UD_ONBOARDING_CONFIG_TITLE: 'Configurações da sua conta',
    UD_ONBOARDING_CONFIG_DESC:
      'Tenha acesso mais direto a todas as configurações da sua conta neste link.',
    UD_ONBOARDING_FAQ_TITLE: 'Resolvendo suas perguntas',
    UD_ONBOARDING_FAQ_DESC:
      'Se você ainda tiver dúvidas sobre o funcionamento da plataforma, com prazer te ajudamos na Central de Ajuda Crehana.',
    UD_ONBOARDING_SEARCH_TITLE: 'O que você está procurando no seu painel?',
    UD_ONBOARDING_SEARCH_DESC:
      'Faça uma pesquisa mais exata do que você precisa em seu painel nesta seção.',
    // Filters & FAQ
    UD_CONFIGURATION: 'Configuração',
    UD_SEARCH_HINT: 'Pesquise cursos, projetos...',
    UD_SEARCH_PROJECT_SUBTITLE: 'Projeto de {{course}}',
    UD_SEARCH_ERROR: 'Ocorreu um erro ao obter as informações do painel.',
    UD_SEARCH_NO_RESULTS:
      'Não conseguimos encontrar resultados para sua pesquisa',
    UD_GO_TO_COURSES: 'Ver os meus cursos',
    UD_FILTER_LABEL: 'Filtrar por',
    UD_FAQ_COURSE: 'Não consigo encontrar meu curso',
    UD_FAQ_PROJECT_UPLOAD: 'Upload de projetos',
    UD_FAQ_START_COURSES: 'Como eu começo meus cursos?',
    UD_FAQ_DIPLOMA: 'Como obter meu diploma?',
    UD_FAQ_ONBOARDING: 'Como funciona o meu painel?',
    UD_FAQ_GENERAL: 'Ainda tem dúvidas? Entre na',
    UD_FAQ_GENERAL_LINK: 'Central de Ajuda Crehana',
    // Enrollments components and actions
    UD_TRACK_TITLE: 'Especialização em {{title}}',
    UD_DURATION: 'Duração: {{duration}}',
    UD_DOWNLOAD_SYLLABUS: 'Faça o download da sílaba',
    UD_DOWNLOAD_DIPLOMA: 'Baixar diploma',
    UD_START_COURSE: 'Iniciar curso',
    UD_CONTINUE_COURSE: 'Continuar curso',
    UD_REWATCH_COURSE: 'Assista novamente',
    UD_CREATE_PROJECT: 'Iniciar projeto',
    UD_EDIT_PROJECT: 'Editar projeto',
    UD_GO_TO_PROJECT: 'Ver projeto',
    UD_MODULE_LIST_PROGRESS: '{{completed}}/{{total}} módulos concluídos',
    UD_COURSE_LIST_PROGRESS: '{{completed}}/{{total}} cursos concluídos',
    UD_PROJECT_LIST_PROGRESS: '{{completed}}/{{total}} projetos certificados',
    UD_SAVED_COURSES_TITLE: 'Cursos salvos',
    UD_SAVED_COURSES_TOUR_TITLE: 'Guardar para ver mais tarde',
    UD_SAVED_COURSES_TITLE_DESC:
      'Agora você pode salvar cursos. Não perca de vista o seu aprendizado!',
    // FAQ'S
    UD_UPLOAD_PROJECTS: 'Como faço o upload dos meus projetos?',
    UD_START_COURSES: 'Como eu começo meus cursos atribuídos?',
    UD_CHAT_WITH_MENTORS: 'Como posso falar com os mentores?',
    UD_UPLOAD_PROJECT: 'Como faço o upload do meu projeto?',
    UD_CANT_FIND_COURSES: 'Não consigo encontrar meus cursos',
    UD_UPLOAD_PROJECTS_TO_PLATFORM:
      'Como faço o upload do meu projeto para a plataforma?',
    UD_PROJECT_DESCRIPTION: 'Onde posso encontrar a descrição do meu projeto?',
    ...EXTERNAL_LOCALES_PT,
  },
};
export default pt;
